import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { FileUploadModule } from 'ng2-file-upload';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule, } from 'ngx-bootstrap/tooltip';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { DataViewModule } from 'primeng/dataview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {SkeletonModule} from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { CarouselModule } from 'primeng/carousel';
import { SpinnerModule } from 'primeng/spinner';
import { PanelModule } from 'primeng/panel';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { RatingModule } from 'primeng/rating';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TableModule } from 'primeng/table';

import { WebshopMappingRoutes } from '@app/webshop/webshop-routing.module';
import { WebshopComponent } from '@app/webshop/shop/webshop.component';
import { ConfirmOrderComponent } from './order/confirm-order/confirm-order.component';
import { BasketOverviewComponent } from '@app/webshop/basket/basket-overview.component';
import { WebshopItemDetailsModalComponent } from '@app/webshop/shop/webshop-item-details-modal.component';
import { OrderDetailsComponent } from '@app/webshop/order-details/order-details.component';
import { ShopSystemModule } from '@app/shared/common/shop-system/shop-system.module';
import { UblCommonModule } from '@app/shared/common/shop-system/common/common.module';
import { AppCommonModule } from '@app/shared/common/app-common.module';

import { OrderOverviewComponent } from './order-overview/order-overview.component';
import { IhscDashboardComponent } from './dashboard/dashboard.component';
import { DataViewComponent } from './shared/common/data-view/data-view.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { DeliverySelectorComponent } from './shared/common/article/delivery-selector.component';
import { AdditionalArticleSelectorComponent } from './shared/common/article/additional-article-selector.component';
import { ConfirmOrderTermsAndConditionsComponent } from './order/confirm-order/terms-and-conditions/confirm-order-terms-and-conditions.component';
import { ConfirmOrderSummaryComponent } from './order/confirm-order/summary/confirm-order-summary.component';
import { ConfirmOrderBackorderComponent } from './order/confirm-order/backorder/confirm-order-backorder.component';
import { BackorderComponent } from './basket/backorder/backorder.component';

import { AxillaCommonModule } from '@axilla/axilla-shared';
import { OnlineHelperModule } from '@axilla/axilla-online-helper';

import { WebshopBannerComponent } from './shared/common/banner/banner.component';
import { WebshopConfigurationComponent } from './configuration/configuration.component';
import { WebshopUtilsModule } from '@shared/utils/utils.module';
import {CombineViewComponent} from '@app/webshop/shared/common/combine-view/combine-view.component';
import {CombineViewSwitcherComponent} from '@app/webshop/shared/common/combine-view/combine-view-switcher.component';
import {TableViewComponent} from '@app/webshop/shared/common/table-view/table-view.component';
import {UniversalCounterComponent} from '@app/webshop/shared/common/universal-counter/universal-counter.component';

@NgModule({

    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule.forChild(WebshopMappingRoutes),
        ModalModule.forRoot(),
        BreadcrumbModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),

        SkeletonModule,
        TableModule,
        SelectButtonModule,
        WebshopUtilsModule,
        DropdownModule,
        ButtonModule,
        PaginatorModule,
        AutoCompleteModule,
        SpinnerModule,
        AxillaCommonModule,
        ShopSystemModule,
        UblCommonModule,
        AppCommonModule,
        ProgressSpinnerModule,
        FileUploadModule,
        DataViewModule,
        PanelModule,
        TagModule,
        DialogModule,
        InputTextModule,
        HttpClientModule,
        RatingModule,
        CarouselModule,

        OnlineHelperModule
    ],
    declarations: [
        WebshopComponent,
        BasketOverviewComponent,
        OrderOverviewComponent,
        IhscDashboardComponent,
        WebshopItemDetailsModalComponent,
        OrderDetailsComponent,
        ConfirmOrderComponent,
        FavoritesComponent,

        DataViewComponent,
        TableViewComponent,
        CombineViewComponent,
        CombineViewSwitcherComponent,
        DeliverySelectorComponent,
        AdditionalArticleSelectorComponent,
        ConfirmOrderTermsAndConditionsComponent,
        ConfirmOrderSummaryComponent,
        ConfirmOrderBackorderComponent,
        BackorderComponent,
        WebshopBannerComponent,
        WebshopConfigurationComponent,

        UniversalCounterComponent,
    ],
    exports: [
        WebshopItemDetailsModalComponent,
        DataViewComponent,
        TableViewComponent,
        CombineViewComponent,
        WebshopBannerComponent,
        DeliverySelectorComponent,
        AdditionalArticleSelectorComponent,
        ConfirmOrderTermsAndConditionsComponent,
        ConfirmOrderSummaryComponent,
        ConfirmOrderBackorderComponent,
        BackorderComponent,
        UniversalCounterComponent,
    ],
    providers: [
        BsModalRef,
    ],

})
export class WebshopModule { }
